/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { RootState } from '../store'

interface PrivateRouteProps {
  component: ComponentType<any>
  children?: ReactNode
  redirectTo?: string
}

export const PrivateRoute = ({
  component: Component,
  redirectTo = '/',
  ...rest
}: PrivateRouteProps) => {
  const { loginSuccess: isAuthenticated } = useSelector(
    (state: RootState) => state.userReducer,
  )

  return !isAuthenticated ? (
    <Navigate to={redirectTo} {...rest} />
  ) : (
    <Component {...rest} />
  )
}
